import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';

export interface ToastContainerProps {
  id?: string;
  className?: string;
  children: React.ReactNode;
}

const ToastContainer: React.FC<ToastContainerProps> = (
  props: ToastContainerProps
) => {
  const { id, className, children } = props;

  const toastContainerClass = classNames('ui-toast-container', className);

  return ReactDOM.createPortal(
    <div id={id} className={toastContainerClass}>
      {children}
    </div>,
    document.body
  );
};

export default ToastContainer;
